import { Box } from "@mui/material";

const SummaryFrame = ({ children }: { children: any }) => {
  return (
    <Box
      className="flex-column-start-start"
      sx={{
        width: "100%",
        maxHeight: 200,
        flexGrow: 1,
      }}
    >
      {children}
    </Box>
  );
};

export default SummaryFrame;
